import { _GroupsQuery } from '../types/planung-graphql-client-defs';

/**
 * `extractClassGroupNamesFromEvent` aus `@bp/shared-planung-utils` erwartet Gruppen noch in der Form
 * der früher generierten Abfrage (`divisionConnection.edges[].node.uuid`). Die eigenen Root-Felder
 * liefern stattdessen `divisionUuid`; hier wird die erwartete Form daraus gebaut.
 */
export const toSharedGroupsData = (groupsData: _GroupsQuery | undefined) =>
  groupsData && {
    groups: groupsData.groups.map((group) => ({
      uuid: group.uuid,
      shortName: group.shortName,
      name: group.name,
      divisionConnection: { edges: [{ node: { uuid: group.divisionUuid } }] },
    })),
  };
